import { BackorderLogic } from './BacorderLogic';
import { ENDPOINT } from './constants';
import { RequestAPI } from './Requests';

export interface ISettingsRequestDTO {
  data: {
    backorderLogic: BackorderLogic;
  };
}

interface SettingsRequestsInterface {
  getSettings: () => Promise<ISettingsRequestDTO>;
}

export const SettingsRequests: SettingsRequestsInterface = {
  getSettings: () => {
    return RequestAPI.get(ENDPOINT.settings.getBackorderLogic);
  },
};
